import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d53fb9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-compact" }
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = { class: "nav" }
const _hoisted_4 = {
  role: "main",
  id: "main"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "main-error" }, "Oops, something went wrong", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oztix_logo = _resolveComponent("oztix-logo")!
  const _component_nav_menu = _resolveComponent("nav-menu")!
  const _component_the_footer = _resolveComponent("the-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", null, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_oztix_logo)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_nav_menu)
      ])
    ]),
    _createElementVNode("main", _hoisted_4, [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _hoisted_5
      ], true)
    ]),
    _createVNode(_component_the_footer)
  ]))
}